(function () {
  const GOOGLE_TRANSLATE_SCRIPT_ID = 'scGoogleTranslateScript';
  const CONSENT_DISMISSED_KEY = 'scConsentDismissed';
  const SUPPORTED_LANGUAGES = [
    'da', 'de', 'fr', 'es', 'it', 'nl', 'pl', 'pt', 'sv', 'no',
    'fi', 'tr', 'ar', 'uk', 'ru', 'hi', 'ja', 'ko', 'zh-CN', 'zh-TW'
  ];
  const MOBILE_BREAKPOINT = '(min-width: 1081px)';
  const DESKTOP_SCALE_BREAKPOINT = 1081;
  const DESKTOP_SCALE_VALUE = '80%';
  const DEFAULT_SCALE_VALUE = '100%';

  function initGoogleTranslateElement() {
    const anchor = document.getElementById('google_translate_element');
    if (!anchor) return;
    if (!window.google || !google.translate || !google.translate.TranslateElement) return;
    if (anchor.dataset.scTranslateReady === 'true') return;

    anchor.dataset.scTranslateReady = 'true';
    new google.translate.TranslateElement(
      {
        pageLanguage: 'en',
        includedLanguages: SUPPORTED_LANGUAGES.join(','),
        autoDisplay: false,
        multilanguagePage: false,
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE
      },
      'google_translate_element'
    );
  }

  function ensureGoogleTranslateLoaded() {
    if (window.google && google.translate && google.translate.TranslateElement) {
      initGoogleTranslateElement();
      return;
    }

    const previousInit = window.googleTranslateElementInit;
    window.googleTranslateElementInit = function () {
      if (typeof previousInit === 'function') previousInit();
      initGoogleTranslateElement();
    };

    if (!document.getElementById(GOOGLE_TRANSLATE_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = GOOGLE_TRANSLATE_SCRIPT_ID;
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.head.appendChild(script);
    }
  }

  function initHomepage(section) {
    if (!section || section.dataset.scHomepageReady === 'true') return;
    section.dataset.scHomepageReady = 'true';

    function applySiteScale() {
      const shouldScaleDesktop = window.innerWidth >= DESKTOP_SCALE_BREAKPOINT;
      document.documentElement.style.fontSize = shouldScaleDesktop ? DESKTOP_SCALE_VALUE : DEFAULT_SCALE_VALUE;
    }

    applySiteScale();

    const root = document.documentElement;
    const header = section.querySelector('.sc-header--live');
    const ctaLinks = Array.from(section.querySelectorAll('[data-shopify-action]'));
    const hashLinks = Array.from(section.querySelectorAll('a[href^="#"]'));
    const faqItems = Array.from(section.querySelectorAll('.sc-faq-item'));
    const backToTopButton = section.querySelector('.sc-back-to-top');
    const tabButtons = Array.from(section.querySelectorAll('.sc-usecase-tab'));
    const tabPanels = Array.from(section.querySelectorAll('.sc-usecase-panel'));
    const languageRoot = section.querySelector('#scLanguage');
    const languageButton = languageRoot
      ? (languageRoot.querySelector('.sc-language-toggle') || languageRoot.querySelector('.sc-lang-btn'))
      : null;
    const languageMenu = section.querySelector('#scLangMenu');
    const languageLinks = languageMenu ? Array.from(languageMenu.querySelectorAll('[data-lang]')) : [];
    const cartStatus = section.querySelector('#scCartStatus');
    const shopSelection = section.querySelector('#scShopSelection');
    const priceMain = section.querySelector('#scPriceMain');
    const addToCartLink = section.querySelector('[data-shopify-action="add-to-cart"]');
    const mobileNav = section.querySelector('[data-mobile-nav]');
    const mobileNavBackdrop = section.querySelector('[data-mobile-nav-backdrop]');
    const mobileNavToggle = section.querySelector('[data-mobile-nav-toggle]');
    const mobileNavClose = section.querySelector('[data-mobile-nav-close]');
    const mobileMedia = window.matchMedia(MOBILE_BREAKPOINT);
    const storeOrigin = section.dataset.shopifyStoreOrigin || window.location.origin;

    const shopify = {
      storeOrigin: storeOrigin,
      productPath: section.dataset.shopifyProductPath || '/products/the-helping-hand-grip-assist-narrow-wide-models',
      cartPath: section.dataset.shopifyCartPath || '/cart',
      currency: section.dataset.shopifyCurrency || 'DKK',
      variants: {
        narrow: section.dataset.shopifyVariantNarrow || '',
        wide: section.dataset.shopifyVariantWide || '',
        bundle: section.dataset.shopifyVariantBundle || ''
      },
      labels: {
        narrow: 'Small Opening',
        wide: 'Wide Opening',
        bundle: 'Small + Large (Set of 2)'
      },
      prices: {
        narrow: 79500,
        wide: 79500,
        bundle: 149500
      }
    };

    let selectedModel = 'wide';
    let mobileHideTimer = 0;
    let mobileBackdropTimer = 0;

    function absolutize(path, origin) {
      return new URL(path, origin).toString();
    }

    function isCompactViewport() {
      return window.innerWidth <= 1080 || !mobileMedia.matches;
    }

    function setNodeHidden(node, shouldHide) {
      if (!node) return;
      node.hidden = shouldHide;
      if (shouldHide) node.setAttribute('hidden', 'hidden');
      else node.removeAttribute('hidden');
    }

    function isMobileNavOpen() {
      return !!(mobileNav && mobileNav.classList.contains('is-open'));
    }

    function getHeaderOffset() {
      const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      const extraGap = window.matchMedia('(max-width: 768px)').matches ? 14 : 24;
      return headerHeight + extraGap;
    }

    function resolveHashTarget(hash) {
      if (!hash || hash === '#') return null;

      const id = decodeURIComponent(hash.slice(1));
      if (!id) return null;

      if (window.CSS && typeof window.CSS.escape === 'function') {
        return section.querySelector('#' + window.CSS.escape(id)) || document.getElementById(id);
      }

      return document.getElementById(id);
    }

    function scrollToHashTarget(hash, behavior, updateHistory) {
      const target = resolveHashTarget(hash);
      if (!target) return false;

      const top = window.scrollY + target.getBoundingClientRect().top - getHeaderOffset();
      window.scrollTo({
        top: Math.max(top, 0),
        behavior: behavior || 'smooth'
      });

      if (updateHistory) {
        if (window.location.hash === hash) {
          history.replaceState(null, '', hash);
        } else {
          history.pushState(null, '', hash);
        }
      }

      return true;
    }

    function syncHashPosition(behavior) {
      if (!window.location.hash) return;
      window.setTimeout(function () {
        scrollToHashTarget(window.location.hash, behavior || 'auto', false);
      }, 40);
    }

    function syncBackToTopVisibility() {
      if (!backToTopButton) return;
      const threshold = isCompactViewport() ? 220 : 280;
      const shouldShow = window.scrollY > threshold;
      setNodeHidden(backToTopButton, !shouldShow);
      if (shouldShow) backToTopButton.style.display = 'inline-flex';
      else backToTopButton.style.removeProperty('display');
      backToTopButton.style.pointerEvents = shouldShow ? 'auto' : 'none';
      backToTopButton.classList.toggle('is-visible', shouldShow);
    }

    function hideGoogleTranslateChrome() {
      const selectors = [
        '#google_translate_element',
        '.sc-google-translate-anchor',
        'body > .skiptranslate',
        '.skiptranslate',
        '.skiptranslate iframe',
        '.goog-te-banner-frame',
        'iframe.goog-te-banner-frame',
        '.goog-te-menu-frame',
        'iframe.goog-te-menu-frame',
        '.goog-te-balloon-frame',
        '#goog-gt-tt',
        '.goog-tooltip',
        '.goog-te-gadget-icon'
      ];

      document.querySelectorAll(selectors.join(',')).forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('opacity', '0', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      });

      document.documentElement.style.top = '0px';
      document.body.style.top = '0px';
    }

    function rememberConsentDismissed() {
      try {
        window.sessionStorage.setItem(CONSENT_DISMISSED_KEY, '1');
      } catch (error) {
        // Ignore storage failures.
      }

      try {
        window.localStorage.setItem(CONSENT_DISMISSED_KEY, '1');
      } catch (error) {
        // Ignore storage failures.
      }
    }

    function isConsentDismissed() {
      try {
        if (window.sessionStorage.getItem(CONSENT_DISMISSED_KEY) === '1') return true;
      } catch (error) {
        // Ignore storage failures.
      }

      try {
        if (window.localStorage.getItem(CONSENT_DISMISSED_KEY) === '1') return true;
      } catch (error) {
        // Ignore storage failures.
      }

      return false;
    }

    function markCookieBannerHidden(node) {
      if (!node) return;
      node.dataset.scConsentHandled = 'true';
      node.classList.add('sc-cookie-hidden');
      node.setAttribute('hidden', 'hidden');
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
      node.style.setProperty('transform', 'translateY(10px)', 'important');
    }

    function hideCookieBanner(force) {
      const banners = Array.from(document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner'));
      if (!banners.length) return false;

      banners.forEach(function (banner) {
        if (!force && banner.dataset.scConsentHandled === 'true') return;

        const dialog = banner.querySelector('.shopify-pc__banner__dialog') || banner.firstElementChild;
        markCookieBannerHidden(dialog);
        markCookieBannerHidden(banner);

        window.setTimeout(function () {
          if (banner && typeof banner.remove === 'function') banner.remove();
        }, force ? 0 : 120);
      });

      return true;
    }

    function dismissCookieBanner() {
      rememberConsentDismissed();
      hideCookieBanner(true);

      window.requestAnimationFrame(function () {
        hideCookieBanner(true);
      });

      window.setTimeout(function () {
        hideCookieBanner(true);
      }, 80);

      window.setTimeout(function () {
        hideCookieBanner(true);
      }, 400);
    }

    function isManageConsentControl(control) {
      if (!control) return false;
      const label = (control.textContent || '').trim().toLowerCase();
      const className = control.className || '';
      return (
        label.indexOf('administrer') !== -1 ||
        label.indexOf('manage') !== -1 ||
        label.indexOf('præferencer') !== -1 ||
        label.indexOf('preferences') !== -1 ||
        className.indexOf('manage-prefs') !== -1
      );
    }

    function bindCookieActions() {
      const banner = document.getElementById('shopify-pc__banner') || document.querySelector('.shopify-pc__banner');
      if (!banner) return;

      banner.querySelectorAll('button, a').forEach(function (control) {
        if (control.dataset.scConsentBound === 'true') return;
        control.dataset.scConsentBound = 'true';

        function dismissIfNeeded() {
          if (isManageConsentControl(control)) return;
          dismissCookieBanner();
        }

        control.addEventListener('pointerup', dismissIfNeeded);
        control.addEventListener('click', dismissIfNeeded);
      });
    }

    function closeLanguageMenu() {
      if (!languageRoot || !languageButton) return;
      languageRoot.classList.remove('is-open');
      languageButton.setAttribute('aria-expanded', 'false');
    }

    function setTranslateCookie(value, days) {
      const maxAge = days * 24 * 60 * 60;
      document.cookie = 'googtrans=' + value + '; path=/; max-age=' + maxAge;
      const host = window.location.hostname;
      if (host.indexOf('.') !== -1) {
        document.cookie = 'googtrans=' + value + '; path=/; domain=.' + host.replace(/^www\./, '') + '; max-age=' + maxAge;
      }
    }

    function clearTranslateCookie() {
      const host = window.location.hostname;
      document.cookie = 'googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      if (host.indexOf('.') !== -1) {
        document.cookie = 'googtrans=; path=/; domain=.' + host.replace(/^www\./, '') + '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
    }

    function getTranslateCombo() {
      return document.querySelector('.goog-te-combo');
    }

    function applyLanguage(lang) {
      if (lang === 'en') {
        clearTranslateCookie();
        window.location.reload();
        return;
      }

      setTranslateCookie('/en/' + lang, 365);

      const combo = getTranslateCombo();
      if (combo) {
        combo.value = lang;
        combo.dispatchEvent(new Event('change'));
        window.setTimeout(function () {
          window.location.reload();
        }, 650);
      } else {
        window.location.reload();
      }
    }

    function activateUsecase(panelId) {
      tabButtons.forEach(function (button) {
        const isMatch = button.getAttribute('aria-controls') === panelId;
        button.classList.toggle('is-active', isMatch);
        button.setAttribute('aria-selected', String(isMatch));
      });

      tabPanels.forEach(function (panel) {
        const isMatch = panel.id === panelId;
        panel.classList.toggle('is-active', isMatch);
        panel.hidden = !isMatch;
      });
    }

    function normalizeModel(model) {
      if (model === 'narrow') return 'narrow';
      if (model === 'bundle') return 'bundle';
      return 'wide';
    }

    function formatPrice(cents) {
      return new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100) + ' DKK';
    }

    function buildProductUrl(model) {
      const variantId = shopify.variants[normalizeModel(model)];
      const url = new URL(shopify.productPath, shopify.storeOrigin);
      if (variantId) url.searchParams.set('variant', variantId);
      if (!variantId && model) url.searchParams.set('model', model);
      return url.toString();
    }

    function buildCartUrl(model) {
      const variantId = shopify.variants[normalizeModel(model)];
      if (variantId) {
        return absolutize(shopify.cartPath.replace(/\/$/, '') + '/' + variantId + ':1', shopify.storeOrigin);
      }
      return buildProductUrl(model);
    }

    function buildEventItem(model) {
      const normalized = normalizeModel(model);
      const price = (shopify.prices[normalized] || shopify.prices.wide || 0) / 100;
      return {
        item_id: shopify.variants[normalized] || normalized,
        item_name: 'The Helping Hand',
        item_brand: 'Sui Cura',
        item_variant: shopify.labels[normalized] || shopify.labels.wide,
        price: Number(price.toFixed(2)),
        quantity: 1
      };
    }

    function pushEvent(eventName, model) {
      const normalized = normalizeModel(model || selectedModel);
      const item = buildEventItem(normalized);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        currency: shopify.currency,
        value: item.price,
        items: [item],
        ecommerce: {
          currency: shopify.currency,
          value: item.price,
          items: [item]
        }
      });
    }

    function setSelectedModel(model, silent) {
      selectedModel = normalizeModel(model);
      root.setAttribute('data-selected-model', selectedModel);

      ctaLinks.forEach(function (link) {
        if (link.dataset.shopifyAction === 'select-model') {
          const isMatch = link.dataset.shopifyModel === selectedModel;
          link.classList.toggle('is-selected', isMatch);
          if (link.matches('button')) link.setAttribute('aria-pressed', String(isMatch));
        }

        if (link.dataset.shopifyAction === 'add-to-cart') {
          link.href = buildCartUrl(selectedModel);
        }
      });

      if (priceMain) priceMain.textContent = formatPrice(shopify.prices[selectedModel] || shopify.prices.wide);
      if (shopSelection) shopSelection.textContent = 'Selected: ' + shopify.labels[selectedModel];
      if (addToCartLink) addToCartLink.setAttribute('aria-label', 'Add ' + shopify.labels[selectedModel] + ' to cart');
      if (!silent && cartStatus) cartStatus.textContent = 'Selected model: ' + shopify.labels[selectedModel];
    }

    function markMobileNavState(isOpen) {
      if (!mobileNav || !mobileNavBackdrop || !mobileNavToggle) return;

      mobileNavToggle.classList.toggle('is-open', isOpen);
      mobileNavToggle.setAttribute('aria-expanded', String(isOpen));
      mobileNavToggle.dataset.navState = isOpen ? 'open' : 'closed';
      mobileNav.setAttribute('aria-hidden', String(!isOpen));
      document.documentElement.classList.toggle('sc-mobile-nav-open', isOpen);
      document.body.classList.toggle('sc-mobile-nav-open', isOpen);
    }

    function closeMobileNav(force) {
      if (!mobileNav || !mobileNavBackdrop || !mobileNavToggle) return;

      window.clearTimeout(mobileHideTimer);
      window.clearTimeout(mobileBackdropTimer);
      markMobileNavState(false);

      if (force) {
        mobileNav.classList.remove('is-open');
        mobileNavBackdrop.classList.remove('is-open');
        setNodeHidden(mobileNav, true);
        setNodeHidden(mobileNavBackdrop, true);
        mobileNav.style.removeProperty('display');
        mobileNavBackdrop.style.removeProperty('display');
        return;
      }

      mobileNav.classList.remove('is-open');
      mobileNavBackdrop.classList.remove('is-open');

      mobileHideTimer = window.setTimeout(function () {
        if (!isMobileNavOpen()) {
          setNodeHidden(mobileNav, true);
          mobileNav.style.removeProperty('display');
        }
      }, 160);

      mobileBackdropTimer = window.setTimeout(function () {
        if (!isMobileNavOpen()) {
          setNodeHidden(mobileNavBackdrop, true);
          mobileNavBackdrop.style.removeProperty('display');
        }
      }, 160);
    }

    function openMobileNav() {
      if (!mobileNav || !mobileNavBackdrop || !mobileNavToggle) return;
      closeLanguageMenu();
      window.clearTimeout(mobileHideTimer);
      window.clearTimeout(mobileBackdropTimer);
      setNodeHidden(mobileNav, false);
      setNodeHidden(mobileNavBackdrop, false);
      mobileNav.style.display = 'block';
      mobileNavBackdrop.style.display = 'block';

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          mobileNav.classList.add('is-open');
          mobileNavBackdrop.classList.add('is-open');
          markMobileNavState(true);
        });
      });
    }

    function toggleMobileNav() {
      if (!mobileNav || !isCompactViewport()) return;
      if (isMobileNavOpen()) closeMobileNav(false);
      else openMobileNav();
    }

    function syncResponsiveState() {
      if (!isCompactViewport()) {
        closeMobileNav(true);
      }
      syncBackToTopVisibility();
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateUsecase(button.getAttribute('aria-controls'));
      });

      button.addEventListener('keydown', function (event) {
        const currentIndex = tabButtons.indexOf(button);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabButtons.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;

        if (nextIndex !== currentIndex) {
          event.preventDefault();
          tabButtons[nextIndex].focus();
          tabButtons[nextIndex].click();
        }
      });
    });

    ctaLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        const action = link.dataset.shopifyAction;
        const model = action === 'add-to-cart' ? selectedModel : (link.dataset.shopifyModel || selectedModel);

        if (action === 'select-model') {
          setSelectedModel(model, false);
          pushEvent('select_item', model);
          return;
        }

        if (action === 'shop') {
          setSelectedModel(model, true);
          pushEvent('view_item', model);
          scrollToHashTarget('#buy-heading', 'smooth', true);
          return;
        }

        if (action === 'add-to-cart') {
          setSelectedModel(model, true);
          link.href = buildCartUrl(selectedModel);
          pushEvent('add_to_cart', selectedModel);
        }
      });
    });

    hashLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        const href = link.getAttribute('href') || '';
        if (!href.startsWith('#')) return;
        if (!resolveHashTarget(href)) return;

        event.preventDefault();

        if (mobileNav && mobileNav.contains(link)) {
          closeMobileNav(false);
          window.setTimeout(function () {
            scrollToHashTarget(href, 'smooth', true);
          }, 220);
          return;
        }

        scrollToHashTarget(href, 'smooth', true);
      });
    });

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        faqItems.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.open = false;
          }
        });
      });
    });

    if (backToTopButton) {
      backToTopButton.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    if (languageButton && languageMenu) {
      languageButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const isOpen = languageRoot.classList.toggle('is-open');
        languageButton.setAttribute('aria-expanded', String(isOpen));
      });

      languageLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          const lang = link.getAttribute('data-lang') || 'en';
          closeLanguageMenu();
          applyLanguage(lang);
        });
      });

      ensureGoogleTranslateLoaded();
      hideGoogleTranslateChrome();
    }

    if (mobileNavToggle) {
      mobileNavToggle.addEventListener('click', function (event) {
        event.preventDefault();
        toggleMobileNav();
      });
    }

    // Expose global helpers for legacy inline handlers in preview builds.
    window.scToggleMobileNav = function () {
      toggleMobileNav();
      return false;
    };
    window.scScrollToTop = function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    };

    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', function () {
        closeMobileNav(false);
      });
    }

    if (mobileNavBackdrop) {
      mobileNavBackdrop.addEventListener('click', function () {
        closeMobileNav(false);
      });
    }

    if (mobileNav) {
      mobileNav.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function () {
          closeMobileNav(false);
        });
      });
    }

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', function (event) {
        applySiteScale();
        if (event.matches) closeMobileNav(true);
      });
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(function (event) {
        applySiteScale();
        if (event.matches) closeMobileNav(true);
      });
    }

    function handleViewportChange() {
      applySiteScale();
      syncResponsiveState();
    }

    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('orientationchange', handleViewportChange);

    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (languageRoot && !languageRoot.contains(target)) closeLanguageMenu();

      const consentTarget = target.closest(
        '.shopify-pc__banner button, .shopify-pc__banner a, #shopify-pc__banner button, #shopify-pc__banner a'
      );

      if (!consentTarget) return;

      if (!isManageConsentControl(consentTarget)) {
        dismissCookieBanner();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeLanguageMenu();
        closeMobileNav(false);
      }
    });

    window.addEventListener('hashchange', function () {
      syncHashPosition('auto');
    });

    window.addEventListener('scroll', syncBackToTopVisibility, { passive: true });

    hideGoogleTranslateChrome();
    if (isConsentDismissed()) hideCookieBanner(true);
    bindCookieActions();

    if (document.body) {
      const translateObserver = new MutationObserver(function () {
        hideGoogleTranslateChrome();
        if (isConsentDismissed()) hideCookieBanner(true);
        bindCookieActions();
      });
      translateObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    setSelectedModel(selectedModel, true);
    pushEvent('view_item', selectedModel);

    if (document.readyState === 'complete') {
      syncHashPosition('auto');
      syncBackToTopVisibility();
      hideGoogleTranslateChrome();
      if (isConsentDismissed()) hideCookieBanner(true);
    } else {
      window.addEventListener('load', function () {
        syncHashPosition('auto');
        syncBackToTopVisibility();
        hideGoogleTranslateChrome();
        if (isConsentDismissed()) hideCookieBanner(true);
      }, { once: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.sc-homepage-live, .sc-landing:not(.sc-product-page)').forEach(initHomepage);
  }

  function installGlobalMobileFallback() {
    const sections = Array.from(document.querySelectorAll('.sc-homepage-live, .sc-landing:not(.sc-product-page)'));
    if (!sections.length) return;

    const compactQuery = window.matchMedia('(max-width: 1080px)');

    sections.forEach(function (section) {
      const toggle = section.querySelector('[data-mobile-nav-toggle]');
      const nav = section.querySelector('[data-mobile-nav]');
      const backdrop = section.querySelector('[data-mobile-nav-backdrop]');
      const close = section.querySelector('[data-mobile-nav-close]');
      const backToTop = section.querySelector('.sc-back-to-top');

      if (toggle && nav && backdrop && toggle.dataset.scDrawerFallbackBound !== 'true') {
        toggle.dataset.scDrawerFallbackBound = 'true';

        const setOpenState = function (isOpen) {
          toggle.setAttribute('aria-expanded', String(isOpen));
          toggle.classList.toggle('is-open', isOpen);
          toggle.dataset.navState = isOpen ? 'open' : 'closed';
          nav.classList.toggle('is-open', isOpen);
          backdrop.classList.toggle('is-open', isOpen);
          nav.setAttribute('aria-hidden', String(!isOpen));
          nav.hidden = !isOpen;
          backdrop.hidden = !isOpen;

          if (isOpen) {
            nav.style.display = 'block';
            backdrop.style.display = 'block';
          } else {
            nav.style.removeProperty('display');
            backdrop.style.removeProperty('display');
          }

          document.documentElement.classList.toggle('sc-mobile-nav-open', isOpen);
          document.body.classList.toggle('sc-mobile-nav-open', isOpen);
        };

        const closeDrawer = function () {
          setOpenState(false);
        };

        const openDrawer = function () {
          setOpenState(true);
        };

        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (window.innerWidth > 1080 && !compactQuery.matches) return;
          if (nav.classList.contains('is-open')) closeDrawer();
          else openDrawer();
        });

        if (close) {
          close.addEventListener('click', function (event) {
            event.preventDefault();
            closeDrawer();
          });
        }

        backdrop.addEventListener('click', closeDrawer);

        nav.querySelectorAll('a[href]').forEach(function (link) {
          link.addEventListener('click', function () {
            closeDrawer();
          });
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') closeDrawer();
        });

        const syncDrawerState = function () {
          if (window.innerWidth > 1080 && !compactQuery.matches) {
            closeDrawer();
          } else if (!nav.classList.contains('is-open')) {
            nav.hidden = true;
            backdrop.hidden = true;
          }
        };

        window.addEventListener('resize', syncDrawerState);
        window.addEventListener('orientationchange', syncDrawerState);
        syncDrawerState();
      }

      if (backToTop && backToTop.dataset.scBackToTopFallbackBound !== 'true') {
        backToTop.dataset.scBackToTopFallbackBound = 'true';

        const refreshBackToTop = function () {
          const threshold = window.innerWidth <= 1080 ? 220 : 280;
          const shouldShow = window.scrollY > threshold;
          backToTop.hidden = !shouldShow;
          if (shouldShow) backToTop.style.display = 'inline-flex';
          else backToTop.style.removeProperty('display');
          backToTop.style.pointerEvents = shouldShow ? 'auto' : 'none';
          backToTop.classList.toggle('is-visible', shouldShow);
        };

        backToTop.addEventListener('click', function (event) {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        window.addEventListener('scroll', refreshBackToTop, { passive: true });
        window.addEventListener('resize', refreshBackToTop);
        window.addEventListener('orientationchange', refreshBackToTop);
        window.addEventListener('load', refreshBackToTop, { once: true });

        window.setTimeout(refreshBackToTop, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      installGlobalMobileFallback();
    }, { once: true });
  } else {
    initAll();
    installGlobalMobileFallback();
  }
})();
